import React, { Component } from 'react';
import { PaddedSection } from '../../atoms';
import ContentConverter from '../../../utils/contentConverter';
import Markdown from 'markdown-to-jsx';
import { Link } from 'react-router-dom';
import { genClassName } from './../../../utils/helpers';
import './styles.css';

/**
 * A template for landing page.
 *
 * @typedef {Object} ImageType
 * @prop {string} src - Image source path
 * @prop {string} alt - Image alt text
 * @prop {string} [title] - Optional image title
 *
 * @typedef {Object} Props
 * @prop {string | string[]} content - Content to display, can be a string or array of strings
 * @prop {string} [subHeading] - Optional subHeading text
 * @prop {string} className - CSS class name
 * @prop {"blue" | "grey"} [subHeadingStyle] - Optional subHeading style, defaults to "blue"
 * @prop {string} [heading] - Optional main heading text
 * @prop {boolean} [headingFirst] - Optional flag to display heading before subHeading
 * @prop {string} [href] - Optional link URL for button
 * @prop {string} [buttonLabel] - Optional button label text
 * @prop {boolean} [reversed] - Optional flag for reversed layout
 * @prop {string} [underButtonText] - Optional text to display under button
 * @prop {ImageType[]} [brandImages] - Optional array of brand images
 *
 * @augments {Component<Props>}
 */
export default class TextImageSecond extends Component {
	getContent = (content) =>
		new ContentConverter(content).convertLinks().nlToBr().getHtml();

	render () {
		const {
			buttonLabel,
			content,
			className,
			heading,
			headingFirst,
			href,
			subHeading,
			subHeadingStyle = 'blue',
			reversed,
			underButtonText,
			// brandImages,
		} = this.props;

		return (
			<PaddedSection
				className={genClassName('TextImageSecond', {
					TextImageSecond_reversed: reversed,
					[className]: className,
				})}
			>
				<div
					className={genClassName('TextImageSecond-image', {
						TextImageSecond_image_reversed: reversed,
					})}
				/>
				<div className='TextImageSecond-content'>
					{!!headingFirst && heading && <h1>{heading}</h1>}
					{subHeading && <h2 className={subHeadingStyle}>{subHeading}</h2>}
					{!headingFirst && heading && <h1>{heading}</h1>}
					{Array.isArray(content) ? (
						content.map((item, index) => (
							// eslint-disable-next-line react/no-array-index-key
							<p key={index}>
								<Markdown
									options={{
										overrides: {
											Link: {
												component: Link,
											},
										},
									}}
								>
									{this.getContent(item)}
								</Markdown>
							</p>
						))
					) : (
						<p>
							<Markdown
								options={{
									overrides: {
										Link: {
											component: Link,
										},
									},
								}}
							>
								{this.getContent(content)}
							</Markdown>
						</p>
					)}
					{/* {brandImages?.length && <BrandIcons images={brandImages}/>} */}
					{href && buttonLabel ? (
						<a
							className='Button TextImageSecond-button '
							href={href}
						>
							<span>{buttonLabel}</span>
						</a>
					) : null}
					{underButtonText && <span className={'underButtonText'}>{underButtonText}</span> }
				</div>
			</PaddedSection>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/templates/TextImageSecond/TextImageSecond.js